import {NgModule} from '@angular/core';
import {IndianCurrencyPipe} from './indian-currency.pipe';
import {registerLocaleData} from '@angular/common';
import localeEnIn from '@angular/common/locales/en-IN';
import {RoundNumberPipe} from './round-number.pipe';
import {DateFormat, DecimalPipe} from '../../loandetail/loandetail.filter';
import {PaymentDateTextColorPipe} from './payment-date-text-color.pipe';

registerLocaleData(localeEnIn);

@NgModule({
    declarations: [IndianCurrencyPipe, RoundNumberPipe, DecimalPipe, DateFormat, PaymentDateTextColorPipe],
    exports: [IndianCurrencyPipe, RoundNumberPipe, DecimalPipe, DateFormat, PaymentDateTextColorPipe]
})
export class PipesModule {
}
